import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import EmployeeCreateView from 'src/sections/employee/view/employee-create-view';

export default function EmployeeCreatePage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Create a new employee</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_EMPLOYEE,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <EmployeeCreateView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
